type BrandTypography = {
  family: string
  fallback?: string
  weight?: number
  size: number
  lineHeight?: number
  style?: string
}

const DEFAULT_TYPOGRAPHY = {
  family: 'Inter',
  fallback: 'sans-serif',
  weight: 400,
  size: 12,
  lineHeight: 1.5,
  style: 'normal',
} satisfies BrandTypography

const parseTypography = (fontShorthand: string): BrandTypography => {
  if (!fontShorthand) return DEFAULT_TYPOGRAPHY
  const regex =
    /(?:(?<style>italic|normal|oblique)\s)?(?:(?<weight>\d{3})\s)?((?<size>\d+)px)?(?:\/(?<lineHeight>\d+(?:\.\d+)?))?\s+"?(?<family>.+)"?(?:,(?<fallback>[\w\s,-]+))?/
  const match = fontShorthand.match(regex)

  if (!match?.groups) {
    return DEFAULT_TYPOGRAPHY
  }

  const { style, weight, size, lineHeight, family, fallback } = match.groups
  return {
    family,
    fallback,
    style,
    size: parseInt(size, 10),
    weight: weight ? parseInt(weight, 10) : undefined,
    lineHeight: lineHeight ? parseInt(lineHeight, 10) : undefined,
  }
}

export { type BrandTypography, parseTypography }
